import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { TenantModeProvider } from "@/contexts/TenantModeContext";
import { TimeTravelProvider } from "@/contexts/TimeTravelContext";
import { USE_MOCK_DATA } from "@/lib/api";
import AppRoutes from "@/routes/AppRoutes";
import "@/App.css";

const TOASTER_OPTIONS = {
  style: {
    background: "hsl(var(--raised))",
    color: "hsl(var(--ink-primary))",
    border: "1px solid hsl(var(--border-subtle))",
  },
};

/**
 * Provider composition order matters and depends on mode:
 *
 *  - Mock mode (Phase 1): MockAuthProvider reads `tenant` from the
 *    TenantModeProvider so the latter must wrap the former.
 *  - API  mode (Phase 3): ApiTenantProvider reads `tenant` from the
 *    authenticated `/api/me` payload exposed by ApiAuthProvider, so the
 *    auth provider must wrap the tenant provider.
 */
function Providers({ children }) {
  if (USE_MOCK_DATA) {
    return (
      <TenantModeProvider>
        <AuthProvider>
          <TimeTravelProvider>{children}</TimeTravelProvider>
        </AuthProvider>
      </TenantModeProvider>
    );
  }
  return (
    <AuthProvider>
      <TenantModeProvider>
        <TimeTravelProvider>{children}</TimeTravelProvider>
      </TenantModeProvider>
    </AuthProvider>
  );
}

/**
 * Root component — composes providers and mounts the route table.
 * Routing lives in `routes/AppRoutes.jsx`.
 */
function App() {
  return (
    <Providers>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <Toaster position="top-right" toastOptions={TOASTER_OPTIONS} />
    </Providers>
  );
}

export default App;
